export class Ata {
	constructor({
		id = null,
		quantidadeDeParticipantes = null,
		formacao = null,
		dataRealizacao = null,
		status = null,
		anexos = []
	}) {
		this.id = id;
		this.quantidadeDeParticipantes = quantidadeDeParticipantes;
		this.formacao = formacao;
		this.dataRealizacao = dataRealizacao;
		this.status = status;
		this.anexos = anexos;
	}
	static Build() {
		return new Ata({
			id: null,
			quantidadeDeParticipantes: null,
			formacao: null,
			dataRealizacao: null,
			status: null,
			anexos: [],
		});
	}
}
  